import {
    CategoriesArray,
    FavoritesTree,
    FixtureElement, FlatTree,
    HostPort,
    PlayerModel,
    SettingsModel,
    SportTreeElement,
    StepForm,
    ThemeInfoType,
    TournamentWithCategoryId,
    ViewType
} from '../../models/api/codegen/code';
import {CouponState} from "./reducers/couponReducer";
import {WidgetIdType} from "./reducers/widgetIdReducer";
import { rightPanelTabType } from './reducers/rightPanelReducer';

export type TreeType = 'PREMATCH' | 'RATING_PREMATCH' | 'LIVE' | 'NONE';

export type TreesType = {
    [key in TreeType]: FlatTree;
};

export enum TimePeriod {
    ALL = 'ALL',
    ONE_HOUR = 'ONE_HOUR',
    TWO_HOURS = 'TWO_HOURS',
    FOUR_HOURS = 'FOUR_HOURS',
    SIX_HOURS = 'SIX_HOURS',
    TWELVE_HOURS = 'TWELVE_HOURS',
    ONE_DAY = 'ONE_DAY',
    TWO_DAYS = 'TWO_DAYS'
}

export type StoreType = {
    spirs: SpirsType
    appSettings: UserSettingsType
    enableDefaultLineStep: boolean
    enableDefaultLiveStep: boolean
    selectResultTab: LiveOrLineType
    loading: boolean
    view: ViewType
    mobileCouponModal: boolean,
    theme: ThemeInfoType,
    loadedTree: boolean,
    type: TreeType
};

export type SpirsType = {
    displayedFixture: FixtureElement;
    widget: WidgetIdType;
    showWidget: boolean;
    sports: SportTreeElement[];
    steps: StepForm[];
    stepsLoaded: boolean;
    playerInfo: PlayerModel;
    playerIsFound: boolean;
    playerRequestCompleted: boolean;
    playerSettings: SettingsModel;
    coupons: CouponState;
    rightPanelTab: rightPanelTabType;
    isGetLimits: boolean;
    isLoadingCoupons: boolean;
    isLoadingSettings: boolean;
    debugMode: boolean;
    playerToken: string;
    playerIdentified: boolean;
    playerIdentifiedLoaded: boolean;
    playerHasAccounts: boolean;
    playerAccountsLoaded: boolean;
    balance?: number;
    playerAuthenticated: boolean;
    playerAuthenticatedLoaded: boolean;
    sportAndChlInResults: ResultInfo,
    fingerprint: object;
    favorites: FavoritesTree;
    favoritesCount: number;
    result: FlatTree;
    selectedSportMenu: number | 'rating' | 'home' | null;
    search: string;
    timePeriodReducer : TimePeriod
    categories: CategoriesArray[];
    categoriesIDReducer: number | 'rating' | 'home' | null;
    tournamentsIDReducer: number | 'rating' | 'home' | null;
    trees: TreesType
};

export type UserSettingsType = {
    displayPeriodMarkets: boolean;
    selectedTournament: TournamentWithCategoryId | null;
    needConfirmDialog: needConfirmDialogType;
    bannerHostPort: HostPort | null;
};

export type needConfirmDialogType = {
    anchorElId: string | null;
};

export type LiveOrLineType = 'LIVE' | 'LINE' | 'NOT_STARTED' | 'FINISHED' | 'WIDGET' | 'LIVE_AND_FINISHED';

export type ResultInfo = {
    sport: boolean,
    chesslive: boolean;
}

export const couponTypeArray = ['ORDINAR', 'EXPRESS', 'SYSTEM'] as const;
